<script>
    import {flip} from 'svelte/animate';
    import Alert from "../stores/alerts";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TourImage from "./TourImage.svelte";

    export let tourId = 0;
    export let images = [];

    let fileinput;
    let imageIndex = 1;
    let hovering = false;

    const initialize = () => {
        images.map(item => {
            imageIndex++;
            item.index = imageIndex;
        });
    }

    const setViewIndex = () => {
        let view_index = 1;
        images.map(item => {
            item.view_index = view_index;
            view_index++;
        });
    }

    const emptyImage = (file) => {
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            Alert.warning("Invalid file type", `Image "${file.name}" is not a valid image type!`);
            return null;
        } else {
            imageIndex++;
            return {
                id: 0,
                index: imageIndex,
                imageObj: null,
                filename: file.name,
                title: '',
                type: file.type,
                view_index: imageIndex,
            }
        }
    }

    const onFileSelected = event => {
        for (let i = 0; i < event.target.files.length; i++) {
            let newImage = emptyImage(event.target.files[i]);
            if (newImage) {
                newImage.fileObj = event.target.files[i];
                images = [...images, newImage];
                setViewIndex();
            }
        }
    }

    const onDelete = ({detail: index}) => {
        images = images.filter(x => x.index != index);
        setViewIndex();
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = images;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        images = newTracklist;
        setViewIndex();
        hovering = null;
    }

    initialize();
</script>

<legend class="py-0">
    Images
    <button class="btn btn-link pe-0" title="add images" on:click="{ ()=>{fileinput.click();} }">
        <span class="btn-flex"><AppIcon icon="plus-circle" size="16" strokeWidth="2" left/>add image</span>
    </button>
</legend>
<div class="images">
    {#each images as image, index (image.index)}
        <div class="image-item"
             animate:flip="{{ duration: 100 }}"
             draggable={true}
             on:dragstart={event => dragstart(event, index)}
             on:drop|preventDefault={event => drop(event, index)}
             ondragover="return false"
             on:dragenter={() => hovering = index}
             class:drag-over={hovering === index}>
            <TourImage {tourId} image="{ image }" index="{ index }" on:delete={ onDelete } on:upload_complete
                       on:upload_error
            />
        </div>
    {/each}
</div>

<input style="display:none" type="file" multiple accept=".jpg, .jpeg, .png"
       on:change={ (event) => onFileSelected(event) }
       bind:this={ fileinput }>

<style>
    .images {
        position: relative;
        min-height: 380px;
    }

    .images:after {
        content: "";
        clear: both;
        display: table;
    }

    .images .image-item {
        position: relative;
        width: 100%;
        padding: 2px 0;
    }
</style>